import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { equal } from '@ember/object/computed';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';

import ignorePromiseFailure from 'cio/utils/ignore-promise-failure';

export default class UrbanAirshipController extends Controller {
  @service api;
  @service alerts;
  @service environment;

  apiURL = 'credentials/urban_airship';
  isEditing = false;
  username = null;
  password = null;
  usernameInputElement = null;

  // used to rollback changes when the cancel button is pressed
  currentUsername = null;

  @equal('loadCredential.last.value', true) isCredentialEnabled;

  @equal('loadCredential.last.value', false) isCredentialDisabled;

  loadCredential = task(
    {
      drop: true,
    },
    async () => {
      try {
        let response = await this.get('api').request(this.get('apiURL'), {
          ignoreErrors: true,
          includeStatus: true,
        });

        this.set('username', response.credential.username);

        return true;
      } catch (e) {
        if (e.status === '404') {
          this.set('username', null);

          return false;
        }
      }
    },
  );

  createOrUpdateCredential = task(async () => {
    let credential = this.getProperties('username', 'password');

    await this.get('api').put(this.get('apiURL'), { data: { credential } });

    this.get('alerts').success('credential.enabled', 'Urban Airship credentials saved!');
    this.set('password', null);
    this.set('isEditing', false);

    await this.get('environment.reload').perform();
    await this.get('loadCredential').perform();

    return true;
  });

  @action
  didInsertUsernameInput(usernameInputElement) {
    this.usernameInputElement = usernameInputElement.querySelector('input');
  }

  @action
  cancelEditing() {
    this.set('isEditing', false);
    this.set('username', this.get('currentUsername'));
    this.set('password', null);
  }

  @action
  startEditing() {
    this.set('isEditing', true);
    this.set('currentUsername', this.get('username'));
    if (this.usernameInputElement == null) {
      return;
    }
    this.usernameInputElement.focus();
  }

  @action
  disableCredential() {
    let promise = this.get('api').delete('credentials/urban_airship');

    promise.then(() => {
      this.get('alerts').success('credential.disabled', 'Urban Airship credentials deleted!');
      this.get('environment.reload').perform();
      this.get('loadCredential').perform();
    }, ignorePromiseFailure);

    return promise;
  }
}
